import { useMsal, useIsAuthenticated, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import Dashboard from './pages/dashboard';
import Coursesmanagement from './pages/coursesManagement';
import ContentManagement from './pages/contentManagement';
import AudienceManagement from './pages/audienceManagement';
import learningPathModal from './pages/learningPath';
import AddNewImage from './pages/addNewImage';
import EditImage from './pages/editModal';
import PageNotFound from './pages/pageNotFound';
import AudienceManageCourses from './pages/audienceManageCourses';
import LearningPathManageCourse from './pages/learningPathManageCourse';
import CreateLearningPath from './pages/createLearningPath';
import CategorySkillsTagsManagement from './pages/categorySkillsTagsManagement';
import CreateCourseWizard from './pages/newCourseWizard';
import { Route, Switch } from 'react-router-dom';
import Home from "./Home";
import CustomLoginComponent from './Login';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import CorsErrorModal from './CorsErrorModal';
import AuthRequiredModal from './AuthRequiredModal';
import { useStore } from 'react-redux';

import Layout from './components/Layout';

import './styles/styles.scss';
import { SET_REMOTE_CONFIG } from "./redux/actions/uiActions";
import { SET_NEW_COURSE_BLOCK_NAVIGATION } from "./redux/actions/newCourseActions";
import RoasterAdminPage from "./pages/roasterAdminPage";
import {SET_AFFILIATE_CODE, SET_SELECTED_AFF_CODE} from "./redux/actions/roaster/roasterListingActions";
import { Redirect } from "react-router-dom/cjs/react-router-dom";
import MarketSegments from "./pages/marketSegments";
import AuthInitializer from './components/AuthInitializer';
import { makeRequest } from "./components/utils/APIsUtils/httpsUtils";
// import { rest } from "lodash";

// Helper component to wrap routes with MsalAuthenticationTemplate
const ProtectedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
          <AuthInitializer>
            <Component {...props} />
          </AuthInitializer>
        </MsalAuthenticationTemplate>
      )}
    />
  );
};

const App = () => {
  const [corsErrorModalOpen, setCorsErrorModalOpen] = React.useState(false);
  const [authRequiredModalOpen, setAuthRequiredModalOpen] = React.useState(false);
  const history = useHistory(); // example from react-router'
  const isAuthenticated = useIsAuthenticated()

  const fetchRemoteConfig = async () => {
    try {
      const apiData = await makeRequest({
        method: 'GET',
        endpoint: `/api/v2/remote-config`,
      });
      if (apiData?.data) {
        store.dispatch({
          type: SET_REMOTE_CONFIG,
          payload: apiData?.data,
        })
        const sales_plan_aff = apiData?.data?.sales_plan_aff?.split(",").map(code => ({ salesPlanAffCode: code,id: code,name:code }));
        store.dispatch({
           type: SET_AFFILIATE_CODE,
           payload : sales_plan_aff
        });
        store.dispatch({
          type: SET_SELECTED_AFF_CODE,
          payload: sales_plan_aff?.length ? sales_plan_aff[0] : {}
        })
      }
    } catch (error) {
      console.error('Failed to fetch remote config:', error);
      // Don't block the app if remote config fails
    }
  }

  useEffect(() => {
    if (isAuthenticated) {
      fetchRemoteConfig().catch(err => {
        console.error('Remote config error:', err);
      });
      store.dispatch({
        type: SET_NEW_COURSE_BLOCK_NAVIGATION,
        payload: false,
      })
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const ignoredRoutes = ["/", "/login", "/dashboard", "/market-segments"];

    const getFullPath = (location) =>
      location.pathname + location.search + location.hash;

    const initialPath = getFullPath(history.location);

    if (history.location.pathname === "/market-segments") {
      store.dispatch({
        type: "SET_LAST_VISITED_URL",
        payload: null,
      });
    } else if (!ignoredRoutes.includes(history.location.pathname)) {
      store.dispatch({
        type: "SET_LAST_VISITED_URL",
        payload: initialPath,
      });
    }

    const unlisten = history.listen((location) => {
      const fullPath = getFullPath(location);

      if (location.pathname === "/market-segments") {
        store.dispatch({
          type: "SET_LAST_VISITED_URL",
          payload: null,
        });
      } else if (!ignoredRoutes.includes(location.pathname)) {
        store.dispatch({
          type: "SET_LAST_VISITED_URL",
          payload: fullPath,
        });
      }
    });

    return () => {
      unlisten();
    };
  }, []);

  const triggerLogin = () => {
    // Redirect to the /login page that has a CustomLoginComponent
    console.log("DEBUG triggerLogin /login")
    history.push('/login');
  };

  const onAuthResume = async () => {
    console.log("DEBUG onAuthResume /login")
    history.push('/login');
  };

  // Removed Okta customAuthHandler and restoreOriginalUri

  const customAuthHandler = () => {
      // MSAL handles auth required differently (e.g. MsalAuthenticationTemplate or PrivateRoute)
      // For now this can be empty or trigger custom logic if needed
      setAuthRequiredModalOpen(true);
  };

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>

          <Layout>
              <CorsErrorModal {...{ corsErrorModalOpen, setCorsErrorModalOpen }} />
              <AuthRequiredModal
                {...{
                  authRequiredModalOpen,
                  setAuthRequiredModalOpen,
                  triggerLogin,
                }}
              />
              <Switch>
                <ProtectedRoute path="/dashboard" exact component={Dashboard} />
                <ProtectedRoute path="/market-segments" exact component={MarketSegments} />
                <ProtectedRoute path="/courses-listing" exact component={Coursesmanagement} />
                <ProtectedRoute path="/image-library" exact component={ContentManagement} />
                <ProtectedRoute path="/user-management" exact component={AudienceManagement} />
                <ProtectedRoute path="/learning-paths-listing" exact component={learningPathModal} />
                <ProtectedRoute path="/add-new-image" exact component={AddNewImage} />
                <ProtectedRoute path="/edit-image" exact component={EditImage} />
                <ProtectedRoute path="/manage-courses" exact component={AudienceManageCourses} />
                <ProtectedRoute path="/manage-learning-paths" expact component={LearningPathManageCourse} />
                <ProtectedRoute path="/learning-path-wizard" exact component={CreateLearningPath} />
                <ProtectedRoute path="/course-wizard" exact component={CreateCourseWizard} />
                <ProtectedRoute
                  path="/cst-management"
                  exact
                  component={CategorySkillsTagsManagement}
                />
                <ProtectedRoute
                  path="/roster-admin"
                  exact
                  component={RoasterAdminPage}
                />
                <ProtectedRoute path="/" exact component={Home} />
                {/* <Route
                  path="/"
                  exact
                  render={(props) => (
                    <AuthInitializer>
                      <Home {...props} />
                    </AuthInitializer>
                  )}
                /> */}
                {/* LoginCallback removed for MSAL */}
                <ProtectedRoute path="/login" exact component={CustomLoginComponent} />
                <Route path="*" component={PageNotFound} />
              </Switch>
              {/* <RouterDetails setCorsErrorModalOpen={setCorsErrorModalOpen} customAuthHandler={customAuthHandler}/> */}
          </Layout>
        </PersistGate>
      </Provider>
      <link
        rel="stylesheet"
        href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.0/css/bootstrap.min.css"
        crossOrigin="anonymous"
      />
    </>
  );
};

export default App;

